import React, { useMemo } from "react";
import { Typography } from "../../../../components";
import { useTranslations } from "../../../../contexts/translation.context";
import { Creator } from "../../../../api/staff";

interface CreatorBalanceCellProps {
  creator: Creator;
}

const formatBalance = (balance: Creator["balance"]) => {
  if (typeof balance === "number") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(balance);
  }

  if (!balance) {
    return "$0.00";
  }

  const parsed = Number(balance);
  if (Number.isNaN(parsed)) {
    return balance;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(parsed);
};

const CreatorBalanceCell: React.FC<CreatorBalanceCellProps> = ({ creator }) => {
  const { t } = useTranslations();

  const lastUpdated = useMemo(() => {
    if (!creator.last_transaction_update) {
      return null;
    }

    try {
      return new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      }).format(new Date(creator.last_transaction_update));
    } catch {
      return creator.last_transaction_update;
    }
  }, [creator.last_transaction_update]);

  return (
    <div className="flex flex-col gap-[6px] py-[8px]">
      <Typography variant="body3" className="text-[#11181C] text-[14px] font-medium">
        {formatBalance(creator.balance)}
      </Typography>

      {lastUpdated && (
        <Typography variant="body4" className="text-[#A1A1AA] text-[12px]">
          {t("creatorDetails.info.lastActivity")}: {lastUpdated}
        </Typography>
      )}
    </div>
  );
};

export default CreatorBalanceCell;
